module.exports = __webpack_public_path__ + "media/images/logo-color-7d4963b49b43e11a0d69fb7d6f562f25.png";